import * as React from "react"
import Modal from "../../molecules/modals/Modal"
import { AnimatePresence } from "framer-motion"
import { HorizontalSpacer } from "../../atoms/spacers"
import BodyTextLarge from "../../atoms/typography/BodyTextLarge"
import { Row, Col } from "react-grid-system"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"

interface BeamMismatchModalProps {
  open: boolean
  onClose: () => void
  activeBeam: string
}

const BeamMismatchModal: React.FunctionComponent<BeamMismatchModalProps> = ({ open, onClose, activeBeam }) => {
  return (
    <AnimatePresence mode="wait">
      {open && (
        <Modal title="Beam Switch Detected!" onClose={onClose} closeIcon>
          <HorizontalSpacer spacing={2} />
          <Row style={{ margin: "0px !important" }}>
            <Col>
              <BodyTextLarge>{`The modem selected a new beam "${activeBeam}"`}</BodyTextLarge>
            </Col>
          </Row>
          <HorizontalSpacer spacing={2} />
          <PrimaryButton onClick={onClose} title="Dismiss" />
        </Modal>
      )}
    </AnimatePresence>
  )
}

export default BeamMismatchModal
